import React from 'react';
import { Link } from 'react-router-dom';
import './403.css';
import paths from '../../paths';

export default function Error404() {
  return (
    <div className="layout lp">
      <header className="page-auth-header">
        <div className="b-center page-auth-header-main">
          <a href={process.env.REACT_APP_LANDING_PAGE_URL} className="CooperVison -m">Cooper Vison</a>
        </div>
      </header>

      <main className="main">
        <div className="b-center error-page">
          <h1>Доступ к разделу запрещен!</h1>
          <p>Авторизуйтесь с правильной учетной записью или свяжитесь с администратором</p>
          <div className="link-container">
            <a href={process.env.REACT_APP_LANDING_PAGE_URL} className="btn -more button button--link">
              {'Перейти на главную страницу'}
            </a>
          </div>
          <div className="link-container">
            <a href={paths.common.signout} className="btn -more button button--link">
              {'Войти под другим аккаунтом'}
            </a>
          </div>
        </div>
      </main>

      <footer className="footer">
        <div className="b-center" style={{ borderTop: 'none', paddingTop: '15px' }}>
          <div className="copyright">
            {`© ${(new Date()).getFullYear()} CooperVision`}
            <span className="copyright-saparation">&nbsp;|&nbsp;</span>
            {'Подразделение компании The Cooper Companies'}
          </div>
          <div className="footer-menu" />
        </div>
      </footer>
    </div>
  );
}
